
export default {
  props: ["v"],
};
